<script lang="ts">
    import { url } from "../stores/stream";
    import Login from "../components/Login.svelte";
    import Video from "../components/Video.svelte";
    import Overlay from "../components/Overlay.svelte";
    import OverlayPitch from "../components/OverlayPitch.svelte";
    import { token } from "../stores/token";
    import "../utils/data-loader";
</script>

<style>
    @media screen {
        div {
            max-width: none;
            height: 100%;
        }
    }

    div {
        display: flex;
        justify-content: center;
    }
</style>

{#if $url === ''}
    {#if $token}
        <div>
            <Video />
            <Overlay />
            <OverlayPitch />
        </div>
    {/if}
    <Login />
{:else}
    <div>
        <Video />
        <Overlay />
        <OverlayPitch />
    </div>
{/if}
